// @core/api/endpoints/activity/get_inbox_counts.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetInboxCountsResponse,
} from '../../../types/activity';

const BASE_PATH = '/activity';

/**
 * Get inbox counts
 * Returns summary counts of unacknowledged activities by category. Used for sidebar badge and My Work focus bar.
 */
export async function GetInboxCounts(
  params?: {
  },
  options?: RequestOptions
): Promise<GetInboxCountsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/inbox/counts`;
  const requestOptions = options;
  return client.get<GetInboxCountsResponse>(requestPath, { ...requestOptions, params });
}
